import templateUrl from 'emun.customer/customer-custom-fields.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class CustomerCustomFieldsController {
    constructor($rootScope) { 
        const $ctrl = this;
        basicController($ctrl);
    }
}

let CustomerCustomFields = {
    bindings: {
        customer: '<',
        fields: '@',
        title: '@',
        rowWidth: '@'
    },
	controller: CustomerCustomFieldsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default CustomerCustomFields